module.exports = __webpack_public_path__ + "static/certificacao-1c3893baaf5d16bd337c6d1791474765.svg";